export default "__VITE_ASSET__53423819__"